import React from 'react';
import Link from '/src/components/global/Link'
import styled from 'styled-components'

const Nav = styled.nav`
  --nav-line-color: var(--bs-lime-green);
  --nav-link-color: var(--bs-primary);
  --nav-link-hover-color: var(--bs-lime-green);
  --nav-link-hover-bg: var(--bs-primary);

  height: 124px;
  @media (min-width: 640px){
    height: 298px;
  }
  //@media (min-width: 992px){
  //  height: 298px;
  //}
  a{
    position: relative;
    color: var(--nav-link-color);
    flex-shrink: 0;
    text-align: center;
    max-width: 150px;
    @media (min-width: 640px){
      max-width: 250px;
    }
    @media (hover) {
      &:hover{
        color: var(--nav-link-hover-color);
        &:after{
          transform: scale(0.96);
        }
      }
    }
    &:after{
      content: '';
      left: 50%;
      top: 50%;
      pointer-events: none;
      position: absolute;
      border-radius: 50%;
      background: var(--nav-link-hover-bg);
      z-index: 0;
      transition: transform 0.2s ease-in-out;
      transform: scale(0);
      @media (min-width: 640px){
        margin-left: -400px;
        margin-top: -200px;
        width: 600px;
        height: 600px;
      }
    }
    @media (min-width: 640px){
      svg{
        width: 64px;
        height: auto;
      }
    }
  }
  .page-next{
    &:after{
      margin-left: -215px;
    }
  }
`
export const PageNav = ({data, style}) => {
  return (data?.prev?.link || data?.next?.link) && (
    <Nav className="overflow-hidden pt-md-60 pe-none" style={style}>
      <div className="container position-relative pt-60 pb-20 pb-md-40 pb-lg-60 h-100">
        <svg className="d-block d-md-none w-auto overflow-visible position-absolute start-50 translate-middle-x bottom-0 z-0" width="375" height="124" viewBox="0 0 375 124" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M441.5 97.8191C424.5-.18089 298 4.36101 223 36.5034c-67.5 28.9281-57.5 61.3157-43 61.3157 31.5.0001 26.5-109.5-187-91.50008-34 2.8665-89 17.18438-114 30.18438" stroke="var(--nav-line-color, #C0EF92)" strokeWidth="8"/>
        </svg>

        <svg className="d-none d-md-block w-100 overflow-visible position-absolute start-0 bottom-0 z-0" width="1440" height="228" viewBox="0 0 1440 228" fill="none" >
          <path d="M1956.5 534C1888.54 141.832 1512.36-11.4381 922 40.4997 751.5 55.4997 591.5 140 631 181.5c66.603 69.975 240-346-788.5-77-95 27-305.7 90.1-388.5 126.5" stroke="var(--nav-line-color, #C0EF92)" strokeWidth="18"/>
        </svg>

        <div className="d-flex justify-content-between align-items-end position-relative z-1 h-100">
          {data?.prev?.link && <Link className="pe-auto page-prev fs-16 fs-md-24 lh-1 text-uppercase font-family-heading d-flex flex-column align-items-center" to={data.prev.link}>
            <span className="position-relative z-1">{data.prev.title}</span>
            <svg className="position-relative z-1 mt-10 mt-md-20" width="36" height="14" viewBox="0 0 36 14" fill="none">
              <use xlinkHref="#icon-arrow-art-l" />
            </svg>
          </Link>}
          {data?.next?.link && <Link className="pe-auto page-next fs-16 fs-md-24 lh-1 text-uppercase font-family-heading d-flex flex-column align-items-center" to={data.next.link}>
            <span className="position-relative z-1">{data.next.title}</span>
            <svg className="position-relative z-1 mt-10 mt-md-20" width="36" height="14">
              <use xlinkHref="#icon-arrow-art-r" />
            </svg>
          </Link>}
        </div>
      </div>
    </Nav>
  );
};
